/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Related_AllInputs */

const en_blog_related_all = /** @type {(inputs: Blog_Related_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All articles`)
};

const lv_blog_related_all = /** @type {(inputs: Blog_Related_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visi raksti`)
};

/**
* | output |
* | --- |
* | "All articles" |
*
* @param {Blog_Related_AllInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_related_all = /** @type {((inputs?: Blog_Related_AllInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Related_AllInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_related_all(inputs)
	return en_blog_related_all(inputs)
});